(function () {
    'use strict';

    angular.module('PWAPoCApp')
        .directive('toaster', function () {
            return {
                restrict: 'E',
                template: `
                    <div class="custom-toaster">
                        <div ng-repeat="toast in toasts track by $index"
                             class="toast {{toast.type}}">
                            <span class="toast-message">{{toast.message}}</span>
                            <button class="toast-close"
                                    ng-click="closeToast(toast)">✕</button>
                        </div>
                    </div>
                `,
                link: function (scope) {
                    scope.toasts = scope.$root.toasts;

                    scope.closeToast = function (toast) {
                        const index = scope.toasts.indexOf(toast);
                        if (index !== -1) {
                            scope.toasts.splice(index, 1);
                        }
                    };
                }
            };
        });
})();
